import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AiAssistants } from '@/pages/dashboard';

const artifactTypes = [
  'cashFlowOverview',
  'categoryOverview',
  'costDriver',
  'categoryExpense',
  'categoryIncome',
  'timeSeries',
  'categoryBreakdown',
  'categoryBar',
  'accountBreakdown',
  'forecastTimeline',
  'documentSummary',
  'documentTimeline',
  'workingCapitalRisk',
  'documentAging',
  'dscrCompliance',
  'kpiMetrics',
  'progressOverview',
  'ranking',
  'trendComparison',
] as const;

const searchSchema = z.object({
  artifact: z.enum(artifactTypes).optional(),
  period: z.string().optional(),
  chatDomain: z.enum(['help', 'finance']).optional(),
  openFloatingChat: z.boolean().optional(),
});

export const Route = createFileRoute('/protected/_layout/dashboard')({
  validateSearch: searchSchema,
  component: AiAssistants,
});
